import type { TFunction } from 'i18next';
import type { AssessmentResultItemDataFragment } from '../../../Trainee/TraineeReports.api';
import type { PhysiologicalResult } from '../../model';

export const buildStrengthPlaceholder = (
    t: TFunction,
    item: AssessmentResultItemDataFragment
): PhysiologicalResult | null => {
    const mi = item.moduleInstance;
    if (!mi?.moduleDefinitionIdentifier) {
        return null;
    }

    return {
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier,
        name: mi.name ?? '',
        description: mi.description ?? '',
        result: [
            {
                label: t('traineeReports:performance.physiologicalFitness.strength.squatRepMaxKg'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.strength.deadliftRepMaxKg'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.strength.maxPullUps'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.strength.sprintDragCarrySec'),
                value: t('traineeReports:na'),
            },
        ],
    };
};

export const buildCardioRespPlaceholder = (
    t: TFunction,
    item: AssessmentResultItemDataFragment
): PhysiologicalResult | null => {
    const mi = item.moduleInstance;
    if (!mi?.moduleDefinitionIdentifier) {
        return null;
    }

    return {
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier,
        name: mi.name ?? '',
        description: mi.description ?? '',
        result: [
            {
                label: t('traineeReports:performance.physiologicalFitness.cardioResp.vo2Max'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.cardioResp.restingHR'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.cardioResp.exerciseHR'),
                value: t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.cardioResp.hrvMs'),
                value: t('traineeReports:na'),
            },
        ],
    };
};
